/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Customer user association tags.
 */
export enum CustomerUserTags {
    SUBMITTER = 'submitter',
    CONTACT = 'contact',
    EDITOR = 'editor',
    INVOICE_RECIPIENT = 'invoice_recipient',
}
